import moment from "moment";
export class StaffBenefits {
  StaffID;
  Seq;
  tempCode;
  IsEditMode;
  PlanCode;
  DateEff;
  DateExp;
  AddBy;
  ModifyBy;
  BenefitDes;
  constructor() {
    this.StaffID = "";
    this.Seq = "";
    this.tempCode =  "";
    this.IsEditMode = false;
    this.PlanCode = "";
    this.DateEff = moment().format("YYYY-MM-DD");
    this.DateExp = moment().format("YYYY-MM-DD");
    this.AddBy = "";
    this.ModifyBy = "";
    this.BenefitDes = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/StaffBenefits.js